<template>
	<div class="home">
		<Encabezado></Encabezado>
		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
							<router-link class="btn GeneralLeave-back btnBack" to="/permisos">
								<font-awesome-icon icon="fa-solid fa-circle-chevron-left" />
								Atrás
							</router-link>
						</div>
						<div class="title">
							<h3>Permisos Retribuidos y Ausencias</h3>
						</div>
					</div>
					<div class="itemList-header">
						<h1>Nuevo permiso retribuido / ausencia</h1>
					</div>
					<div class="item-Form">
						<div class="panel-body">
							<form
								class="form-horizontal"
								id="formNuevoPermiso"
								@submit.prevent="enviarDatosFormulario"
							>
								<div class="form-group">
									<div class="col-md-12 col-xs-12">
										<label for="GeneralLeave_TipoAusenciaValue"
											>Motivo del Permiso</label
										>
										<select v-if="estaDeBaja"
											v-model="idTipoAusencia"
											class="form-control valid"
											data-val="true"
											data-val-number="The field Motivo de Permiso must be a number."
											data-val-required="El campo Motivo de Permiso es obligatorio."
											id="GeneralLeave_TipoAusenciaValue"
											name="GeneralLeave_TipoAusenciaValue"
										>
											<option value="0">Selecciona un Motivo</option>
											<option
												v-for="tipoAusencia in tiposAusenciaEnBaja"
												:value="tipoAusencia.id"
											>
												{{ tipoAusencia.nombre }}
											</option>
										</select>

										<select v-else
											v-model="idTipoAusencia"
											class="form-control valid"
											data-val="true"
											data-val-number="The field Motivo de Permiso must be a number."
											data-val-required="El campo Motivo de Permiso es obligatorio."
											id="GeneralLeave_TipoAusenciaValue"
											name="GeneralLeave_TipoAusenciaValue"
										>
											<option value="0">Selecciona un Motivo</option>
											<option
												v-for="tipoAusencia in tiposAusencia"
												:value="tipoAusencia.id"
											>
												{{ tipoAusencia.nombre }}
											</option>
										</select>


										<div 
											v-if="idTipoAusencia!='0' && fijoDicontinuoDeBajaAntes1Sept"
											class="col-md-12 col-xs-12 alert alert-warning"
											style="margin-top: 20px; font-weight: bold;"
										>
												<font-awesome-icon icon="fa-solid fa-triangle-exclamation" />
												ATENCIÓN: El plazo para el tipo de solicitud seleccionado comienza el <u>1 de Septiembre</u>.
										</div>
										


										<span v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" id="descripcionTipoAusencia">
											<div>
												<div>
													<span>
														{{ tipoAusenciaSeleccionado.descripcion }}
													</span>
												</div>
												<div>
													<small
														v-if="
															tipoAusenciaSeleccionado.descripcionJustificante
														"
													>
														Justificación:
														{{
															tipoAusenciaSeleccionado.descripcionJustificante
														}}
													</small>
												</div>
											</div>
										</span>

										<hr v-if="idTipoAusencia!='0' && superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" />

										<span 
										v-if="idTipoAusencia!='0' && superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" 
										id="avisoNumPermisosSuperado">
											<div class="alert alert-danger">
												<font-awesome-icon icon="fa-solid fa-ban" /> No es posible solicitar más permisos por <strong>{{ tipoAusenciaSeleccionado.nombre }}</strong>	porque se ha alcanzado el máximo anual (<strong>{{ tipoAusenciaSeleccionado.maximoAnual }}</strong>)
											</div>
										</span>
									</div>
								</div>
								<hr v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" />
								<div v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" class="form-group">
									<div class="col-md-6 col-xs-12">
										<label for="fechaDesde">Fecha Desde</label>
										<br />
										<date-picker
											id="fechaDesde"
											class="dateTimePicker"
											v-model="fechaDesde"
											value-type="format"
											:editable="false"
											:formatter="momentFormat"
											:clearable="false"
										></date-picker>
										<br />
										<date-picker
											v-if="permiteHoras"
											class="dateTimePicker"
											v-model="horaDesde"
											format="HH:mm"
											value-type="format"
											type="time"
											:editable="false"
											:minute-step="5"
											:clearable="false"
											:disabled="numDias > 1"
										></date-picker>
										<br />
										<br />
									</div>
									<div class="col-md-6 col-xs-12">
										<label for="fechaHasta">Fecha Hasta</label>
										<br />
										<date-picker
											id="fechaHasta"
											class="dateTimePicker"
											v-model="fechaHasta"
											value-type="format"
											:editable="false"
											:formatter="momentFormat"
											:clearable="false"
										></date-picker>
										<br />
										<date-picker
											v-if="permiteHoras"
											class="dateTimePicker"
											v-model="horaHasta"
											format="HH:mm"
											value-type="format"
											type="time"
											:editable="false"
											:minute-step="5"
											:clearable="false"
											:disabled="numDias > 1"
										></date-picker>
										<br />
										<br />
									</div>
								</div>
								<div v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" class="form-group">
									<div class="col-md-6 col-xs-12">
										<label for="numDias">Número de días ({{ leyendaDiasHabilesNaturales }})</label>
										<input
											class="form-control"
											id="numDias"
											name="numDias"
											readonly="readonly"
											type="text"
											:value="numDiasFormateado"
										/>
									</div>
									<div
										v-if="permiteHoras"
										class="col-md-6 col-xs-12"
										style="display: block"
									>
										<label for="numHoras">Número de horas</label>
										<input
											class="form-control"
											id="numHoras"
											name="numHoras"
											readonly="readonly"
											type="text"
											:value="numHorasFormateado"
										/>
									</div>
								</div>
								<hr v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" />

								<div v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" class="divAttachment">
									<div class="form-group">
										<div class="col-md-12">
											<label>Archivos adjuntos (máx. 3 archivos de 10Mb cada uno)</label>

											<br />
											<br />

											<input
												id="adjunto_1"
												class="hidden"
												type="file"
												ref="adjunto_1"
												@change="cambio_adjunto('adjunto_1')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>

											<div class="input-group">
												<input
													placeholder="Archivo adjunto 1"
													type="text"
													id="caja_adjunto_1"
													class="form-control"
													readonly
													:value="nombreAdjunto_1"
													@click="seleccionarAdjunto('adjunto_1')"
												/>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-warning"
														@click="seleccionarAdjunto('adjunto_1')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														Adjuntar
													</button>
												</span>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-danger"
														@click="quitarAdjunto('adjunto_1')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
											</div>

											<br />
											<br />

											<input
												id="adjunto_2"
												class="hidden"
												type="file"
												ref="adjunto_2"
												@change="cambio_adjunto('adjunto_2')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>

											<div class="input-group">
												<input
													placeholder="Archivo adjunto 2"
													type="text"
													id="caja_adjunto_2"
													class="form-control"
													readonly
													:value="nombreAdjunto_2"
													@click="seleccionarAdjunto('adjunto_2')"
												/>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-warning"
														@click="seleccionarAdjunto('adjunto_2')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														Adjuntar
													</button>
												</span>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-danger"
														@click="quitarAdjunto('adjunto_2')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
											</div>

											<br />
											<br />

											<input
												id="adjunto_3"
												class="hidden"
												type="file"
												ref="adjunto_3"
												@change="cambio_adjunto('adjunto_3')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>

											<div class="input-group">
												<input
													placeholder="Archivo adjunto 3"
													type="text"
													id="caja_adjunto_3"
													class="form-control"
													readonly
													:value="nombreAdjunto_3"
													@click="seleccionarAdjunto('adjunto_3')"
												/>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-warning"
														@click="seleccionarAdjunto('adjunto_3')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														<!-- <font-awesome-icon icon="fa-solid fa-folder" /> -->
														<!-- <font-awesome-icon icon="fa-solid fa-camera" /> -->
														Adjuntar
													</button>
												</span>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-danger"
														@click="quitarAdjunto('adjunto_3')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
											</div>
										</div>
									</div>
								</div>

								<hr v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" />

								<div v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" class="form-group">
									<div class="col-md-12">
										<label for="observaciones">Observaciones</label>
										<textarea
											class="form-control"
											cols="20"
											id="observaciones"
											name="observaciones"
											v-model="observaciones"
											rows="5"
										></textarea>
									</div>
								</div>
								<div class="form-group">
									<div class="col-md-12"></div>
								</div>
								<div v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" class="form-group">
									<div class="col-md-12">
										<div v-if="superaMaximoDias" class="text-danger">
											Aviso.- El número de días no puede superar lo establecido
											(<strong
												>{{ tipoAusenciaSeleccionado.maximoDias }} día/s</strong
											>)
										</div>
										<div v-if="!cumpleJustificante" class="text-danger">
											Aviso.- El tipo de permiso seleccionado requiere que
											adjunte un justificante (<strong>{{
												tipoAusenciaSeleccionado.descripcionJustificante.trim()
											}}</strong>)
										</div>
										<div v-if="tipoNoPermiteDiasConsecutivosYesConsecutivo" class="text-danger">
											Aviso.- No es posible solicitar permiso por <strong>{{ tipoAusenciaSeleccionado.nombre }}</strong> para el/los mismo/s día/s (o día/s consecutivo/s) a los ya solicitados.
										</div>
									</div>
								</div>
								<div v-if="idTipoAusencia!='0' && !superaMaximoAnual && !fijoDicontinuoDeBajaAntes1Sept" class="form-group">
									<div class="col-md-12">
										<input
										:disabled="!datosValidos || enviandoDatosFormulario"
											type="submit"
											class="btn btn-lg btn-primary"
											id="btnSave"
											:value="textoBtnEnvio"
										/>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<!-- <div>esAndroid: {{ esAndroid }}</div> -->
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";
import router from "@/router";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

export default {
	name: "NuevoPermiso",
	components: {
		Encabezado,
		Footer,
		DatePicker,
	},
	data() {
		return {
			idTipoAusencia: "0",
			fechaDesde: moment(new Date()).format("L"),
			fechaHasta: moment(new Date()).format("L"),
			horaDesde: "00:00",
			horaHasta: "00:00",
			adjunto_1: null,
			adjunto_2: null,
			adjunto_3: null,
			observaciones: null,
			momentFormat: {
				//[optional] Date to String
				stringify: (date) => {
					return date ? moment(date).format("L") : "";
				},
				//[optional]  String to Date
				parse: (value) => {
					return value ? moment(value, "L").toDate() : null;
				},
				//[optional] getWeekNumber
				getWeek: (date) => {
					return; // a number
				},
			},
			limiteMegasAdjuntos: 10,
			esAndroid: /Android/i.test(navigator.userAgent)
		};
	},
	mounted() {
		this.$store.commit('establecerEstadoEnviandoDatosFormulario', false);
		this.$store.commit('establecerGuardadoOK', false);
		document.body.classList.remove("bg-login");
		document.body.classList.remove("login-page");

		this.idTipoAusencia = "0";
		//console.log("Aquí estoy...");
		console.log(`Contrato: ${JSON.stringify(this.empleado.contrato)}`);
		console.log(`Baja: ${JSON.stringify(this.empleado.baja)}`);
		console.log(`Fecha Actual: ${JSON.stringify(this.empleado.fechaActual)}`);
		console.log(`Excluido: ${JSON.stringify(this.empleado.excluidoFijoDiscontinuo)}`);
		
	},
	watch: {
		fechaDesde: function(){
			if (this.numDias < 1){
				this.fechaHasta = this.fechaDesde;
			}
		},
		fechaHasta: function(){
			if (this.numDias < 1){
				this.fechaHasta = this.fechaDesde;
			}
		},
		horaDesde: function () {
			if (this.numHoras < 0) {
				this.horaHasta = this.horaDesde;
			}
		},
		horaHasta: function () {
			if (this.numHoras < 0) {
				this.horaHasta = this.horaDesde;
			}
		},
		guardadoOK: function(newValue){
			if (newValue){
				this.$toast.open({
					message: "Los datos se han guardado correctamente",
					type: "success",
					duration: 1000,
					dismissible: false,
					position: "top",
					onDismiss: this.redireccionListaPermisos
				});
			}
		}
	},
	computed: {
		guardadoOK: function(){
            return this.$store.state.guardadoOK;
        },
		permiteHoras: function () {
			return this.tipoAusenciaSeleccionado.permiteHoras * 1;
		},
		numDias: function () {
			const desde = moment(this.fechaDesde, "L");
			const hasta = moment(this.fechaHasta, "L");
			let dias = hasta.diff(desde, "days");

			if (dias) {
				this.horaDesde = "00:00";
				this.horaHasta = "00:00";
			}

			if (!this.diaNatural){
				const festivosIncluidos = this.festivos.filter((x) => 
					moment(x).isBetween(desde, hasta, undefined, '[]')
				);
				
				dias -= festivosIncluidos.length;
			}

			return dias + 1;
		},
		festivos: function(){
			return this.$store.state.perfil.calendario.map((x) => x.festivo);
		},
		numDiasFormateado: function(){
			return (this.numHoras)? 0 : this.numDias;
		},
		diaNatural: function(){
			return !!(this.tipoAusenciaSeleccionado.diaNatural * 1);
		},
		leyendaDiasHabilesNaturales: function(){
			return (this.diaNatural)? 'naturales' : 'hábiles';
		},
		numHoras: function () {
			const desde = moment(this.horaDesde, "HH:mm");
			const hasta = moment(this.horaHasta, "HH:mm");
			const horas = hasta.diff(desde, "minutes");

			return horas;
		},
		numHorasFormateado: function(){
			const horas = `0${Math.floor(this.numHoras / 60)}`.slice(-2);
			const minutos = `0${this.numHoras % 60}`.slice(-2);

			return `${horas}:${minutos}`;
		},
		tiposAusencia: function () {
			const tiposAusencia = this.$store.state.perfil.tiposAusencia || [];
			console.log('tiposAusencia:' , tiposAusencia.length);
			return Array.isArray(tiposAusencia) ? tiposAusencia : [tiposAusencia];
		},
		tiposAusenciaEnBaja: function () {
			const tiposAusencia = this.$store.state.perfil.tiposAusencia.filter(tipo => !!(tipo.fijosDiscontinuosBaja * 1)) || [];
			console.log(tiposAusencia);
			return Array.isArray(tiposAusencia) ? tiposAusencia : [tiposAusencia];
		},
		tipoAusenciaSeleccionado: function () {
			const self = this;
			
			return self.tiposAusencia.find((tipoAusencia) => {
				return tipoAusencia.id == self.idTipoAusencia;
			});
		},
		superaMaximoDias: function () {
			if (this.tipoAusenciaSeleccionado.maximoDias == 0){
				return false;
			}
			if (this.tipoAusenciaSeleccionado.maximoDias > 0){
				return this.numDias > this.tipoAusenciaSeleccionado.maximoDias;
			}

			return this.numDias > 1;
		},
		requiereJustificante: function () {
			return (!!(this.tipoAusenciaSeleccionado.justificante * 1));
		},
		adjuntaJustificante: function () {
			return (!!this.adjunto_1 || !!this.adjunto_2 || !!this.adjunto_3);
		},
		cumpleJustificante: function () {
			return !this.requiereJustificante || (this.requiereJustificante && this.adjuntaJustificante);
		},
		datosValidos: function () {
			if (this.superaMaximoDias) return false;
			if (!this.cumpleJustificante) return false;
			if (this.tipoNoPermiteDiasConsecutivosYesConsecutivo) return false;

			return true;
		},
		textoBtnEnvio: function() {
			if (this.enviandoDatosFormulario) return 'Enviando...';
			if (this.datosValidos) return 'Enviar';
			if (!this.datosValidos) return 'Revise Avisos';  
		},
		tamanioMaximoAdjuntos: function(){
			return this.limiteMegasAdjuntos * 1048576;
		},
		enviandoDatosFormulario: function(){
			return this.$store.state.enviandoDatosFormulario; 
		},
		nombreAdjunto_1: function () {
			return !!this.adjunto_1 ? this.adjunto_1.name : "";
		},
		nombreAdjunto_2: function () {
			return !!this.adjunto_2 ? this.adjunto_2.name : "";
		},
		nombreAdjunto_3: function () {
			return !!this.adjunto_3 ? this.adjunto_3.name : "";
		},
		superaMaximoAnual: function(){
			const self = this;
			const moment = self.moment;
			const maximoAnual = (self.tipoAusenciaSeleccionado?.maximoAnual || '0') * 1;
			let permisos = self.$store.state.perfil.permisos || [];
			
			if (!maximoAnual) return false;

			permisos = Array.isArray(permisos)?permisos:[permisos];

			const permisosFiltrados = permisos.filter(function(permiso){
				const anioPermiso = moment(permiso.fechaHasta, 'YYYY-MM-DD').format('YYYY');
				const anioActual = moment().format('YYYY');
				const esteAnio = anioPermiso === anioActual;
				const mismoTipo = permiso.id_tipoAusencia === self.idTipoAusencia;
				const noRechazado = permiso.estado !== 'Rechazado';
				const noAnuladoPorTrabajador = permiso.estado !== 'Anulado por trabajador';
				
				return esteAnio && mismoTipo && noRechazado && noAnuladoPorTrabajador;
			});

			return permisosFiltrados.length >= maximoAnual;
		},
		tipoPermiteDiasConsecutivos: function(){
			const { diasConsecutivos } = this.tipoAusenciaSeleccionado;
			return !!(diasConsecutivos * 1);
		},
		tipoNoPermiteDiasConsecutivosYesConsecutivo: function(){
			if (!this.tipoPermiteDiasConsecutivos) {
				const self = this;
				const desdeSeleccionado = moment(this.fechaDesde, "L");
				const hastaSeleccionado = moment(this.fechaHasta, "L");
				let permisos = this.$store.state.perfil.permisos || [];

				permisos = Array.isArray(permisos)?permisos:[permisos];

				return permisos.filter(function(permiso){
					const mismoTipo = permiso.id_tipoAusencia === self.idTipoAusencia;
					const noRechazado = permiso.estado !== 'Rechazado';
					const noAnuladoPorTrabajador = permiso.estado !== 'Anulado por trabajador';
					return (mismoTipo && noRechazado && noAnuladoPorTrabajador);
				}).some(function(permiso){
					const desdeMenosUnDia = moment(permiso.fechaDesde, "YYYY-MM-DD").subtract(1, 'days');
					const hastaMasUnDia = moment(permiso.fechaHasta, "YYYY-MM-DD").add(1, 'days');
					const checkDesde = desdeSeleccionado.isBetween(desdeMenosUnDia, hastaMasUnDia, undefined, '[]');
					const checkHasta = hastaSeleccionado.isBetween(desdeMenosUnDia, hastaMasUnDia, undefined, '[]');
					return (checkDesde || checkHasta);
				});
			}
			return false;
		},
		empleado: function(){
			return this.$store.state.perfil.empleado;
			// .contrato;
			// .baja;
			// .fechaActual;
			// .excluidoFijoDiscontinuo;
		},
		estaDeBaja: function(){
			return !!(this.empleado.baja * 1);
			
			//return true;
		},
		antes1sept: function(){
			const fechaActual = moment(this.empleado.fechaActual).startOf('day');
			const fechaLimite = moment(`${fechaActual.year()}-08-31`);
			const fechaLimiteSuperada = fechaActual.diff(fechaLimite, "days") > 0;

			return !fechaLimiteSuperada;

			//return true;
		},
		fijoDicontinuoDeBajaAntes1Sept: function(){
			return this.estaDeBaja && this.antes1sept;
		}
	},
	methods: {
		formatDate: function (date) {
			return this.moment(date).format("DD/MM/YYYY hh:mm");
		},
		enviarDatosFormulario: function () {
			this.$store.dispatch("enviarDatosNuevoPermiso", {
				idTipoAusencia: this.idTipoAusencia,
				fechaDesde: this.fechaDesde,
				fechaHasta: this.fechaHasta,
				horaDesde: this.horaDesde,
				horaHasta: this.horaHasta,
				adjunto_1: this.adjunto_1,
                adjunto_2: this.adjunto_2,
                adjunto_3: this.adjunto_3,
                observaciones: this.observaciones
			});
		},
		seleccionarAdjunto: function(id) {
			this.$refs[id].click();
		},
		quitarAdjunto: function(id) {
			this.$refs[id].value = "";
			if (id == 'adjunto_1') return this.adjunto_1 = null;
			if (id == 'adjunto_2') return this.adjunto_2 = null;
			if (id == 'adjunto_3') return this.adjunto_3 = null;
		},
		cambio_adjunto: function(id){
			const adjunto = this.$refs[id].files[0];
			const nombres_adjuntos = [
				this.nombreAdjunto_1.toUpperCase(), 
				this.nombreAdjunto_2.toUpperCase(), 
				this.nombreAdjunto_3.toUpperCase()
			];
			const expresionRegularExtension = /\.(pdf|jpe?g)$/i;

			this.$refs[id].value = "";

			if (!expresionRegularExtension.test(adjunto.name)){
				return this.mostrarMensajeErrorNombreArchivoConExtensionNoPermitida();
			}

			if (nombres_adjuntos.includes(adjunto.name.toUpperCase())){
				if (adjunto.name.toUpperCase() === 'IMAGE.JPG'){
					const archivo = adjunto;
					const nombreUnico = `imagen_${Date.now()}.jpg`;
					const archivoRenombrado = new File([archivo], nombreUnico, {
						type: archivo.type,
						lastModified: archivo.lastModified
					});
					if (id === "adjunto_1") return this.adjunto_1 = archivoRenombrado;
					if (id === "adjunto_2") return this.adjunto_2 = archivoRenombrado;
					if (id === "adjunto_3") return this.adjunto_3 = archivoRenombrado;
				}
				return this.mostrarMensajeErrorMismoNombreAdjunto();
			}

			if (adjunto.size < this.tamanioMaximoAdjuntos){
				if (id === "adjunto_1") return this.adjunto_1 = adjunto;
				if (id === "adjunto_2") return this.adjunto_2 = adjunto;
				if (id === "adjunto_3") return this.adjunto_3 = adjunto;
			}

			this.mostrarMensajeErrorTamanioAdjunto();	
		},
		mostrarMensajeErrorMismoNombreAdjunto: function(){
			this.$toast.open({
				message: "Ya existe un archivo con el mismo nombre",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top"
			});	
		},
		mostrarMensajeErrorNombreArchivoConCaracteresEspeciales: function(){
			this.$toast.open({
				message: "No se pueden añadir archivos con caracteres especiales en el nombre (ni eñes ni acentos)",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top"
			});	
		},
		mostrarMensajeErrorTamanioAdjunto: function(){
			this.$toast.open({
				message: "No es posible adjuntar archivos de más de 10Mb",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top"
			});
		},
		mostrarMensajeErrorNombreArchivoConExtensionNoPermitida: function(){
			this.$toast.open({
				message: "Solo es posible adjuntar archivos pdf, jpg o jpeg",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top"
			});
		},
		redireccionListaPermisos: function(){
			router.replace('/permisos');
			this.$store.commit('establecerGuardadoOK', false);
		}
	},
};
</script>

<style>
@import "../assets/styles/home.css";
.dateTimePicker {
	width: 100%;
}
</style>
